module.exports = __webpack_public_path__ + "static/media/stock-vector-silhouette-of-parents-and-children-127045523.7d882c27.jpg";